import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/share';

@Injectable()
export class SpinnerService {

  public status: Subject<boolean> = new Subject<boolean>();
  private _active: boolean = false;

  constructor() { }

  public get active(): boolean {
    return this._active;
  }

  public set active(v: boolean) {
    this._active = v;
    this.status.next(v);
  }

  public start(){
    this.active = true;
  }

  public stop(){
    this.active = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/spinner.service.ts